import { create, all } from 'mathjs';
import config from '../../config';
import { PRODUCTS, convertSAPKeyToFrontendKey, convertProductKeyToSAPKey } from '../../constants/Products';

const math = create(all, { number: 'BigNumber', precision: 20 });

const NARCAN_ID = 'NAR062702';
const WALL_UNIT_ID = 'NAR200008';
const NARCAN_CASE_ID = 'NAR99999'; //todo rmm



export const calculateLineItemShipping = (lineItem: any, allOrderlineItems: any[]) => {
  const backendId = convertProductKeyToSAPKey(lineItem.id);


  if (config.grantFreeShipping) {
    return 0
  }

  if (lineItem.quantity === 0) {
    return 0
  }
 
  if (backendId === NARCAN_ID) {//only charge for small qty narcan shipping if < 7 and no Wall Unit or Narcan Case ordered with it
     if (lineItem.quantity < 7 && !(doesOrderContainProductThatGrantsFreeShipping(allOrderlineItems))) {
       return 6.5
     }
     else {
       return 0
     }
  }
  else if (backendId === WALL_UNIT_ID) {
    if (lineItem.quantity < 2) {
      return 15
    }
    else {
      return 0
    }
  }
  else if (backendId === NARCAN_CASE_ID) {
    return 0
  }
  else {
    return 0
  }
}

export const calculateNarcanOrderTotalShipping = (allOrderlineItems: any[]) => {

  if (config.grantFreeShipping) {
    return 0
  }

  let totalShipping = 0;

  for (let i=0; i<allOrderlineItems.length; i++) {
    totalShipping += calculateLineItemShipping(allOrderlineItems[i], allOrderlineItems) || 0;
  }

  return math.round(totalShipping, 2);
}

export const doesOrderContainProductThatGrantsFreeShipping = (allOrderlineItems: any[]) => {

  return Boolean(allOrderlineItems.find((li: any) => {
    const thisSAPId = convertProductKeyToSAPKey(li.id);

    return ( thisSAPId === WALL_UNIT_ID ) || ( thisSAPId === NARCAN_CASE_ID );
  }));
}










